import { RxWithTherapistsDto, RxLifespanDto } from "../../../api-client";
import { navigateToPatientRx } from "./handleRxNavigation";
import PatientsStore from "../../../stores/Patients/patientsStore";

interface PlotClickData {
    points: Array<{
        pointIndex: number;
        curveNumber: number;
    }>;
}

export const handleRxPlotClick = (
    data: PlotClickData, 
    countData: (RxWithTherapistsDto | RxLifespanDto)[],
    patientsStore: PatientsStore
) => {
    if (data.points && data.points.length > 0) {
        const point = data.points[0];
        const pointIndex = point.pointIndex;
        const curveNumber = point.curveNumber;
        
        // Group data by locationId (same logic as in the plot components)
        const groupedData = Object.groupBy(countData, ({ locationId }) => locationId);
        const locationIds = Object.keys(groupedData);
        
        // Get the specific location's data based on curve number
        const locationId = locationIds[curveNumber];
        const locationData = groupedData[locationId];
        
        if (!locationData || pointIndex >= locationData.length) {
            console.warn('No data found for clicked point', { pointIndex, curveNumber, locationId });
            return;
        }
        
        const clickedRx = locationData[pointIndex];
        
        if (!clickedRx) {
            console.warn('No data found for clicked point');
            return;
        }

        const rxId = clickedRx.rxId;
        const patientId = clickedRx.patient.id;
        navigateToPatientRx(rxId, patientId, patientsStore);
    }
};